import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
  },
});

// ─────────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────────

function storageAvailable(type) {
  try {
    const storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

function getSettings() {
  try {
    const raw = sessionStorage.getItem('settings');
    return raw ? JSON.parse(raw) : null;
  } catch {
    sessionStorage.removeItem('settings');
    return null;
  }
}

// true if accessed via casagaja.ibookrestaurant.com or casagaja.aibooking.it
// (not www, not root domain)
function isSubdomainHost() {
  const parts = window.location.host.split('.');
  return parts.length > 2 && parts[0] !== 'www';
}

// on subdomain, ONLY 2-char paths are booking paths (/db /wa /fb /go ...)
// anything longer (/manage /whatsapp /manage_db) must be blocked
function isAllowedOnSubdomain(path) {
  const segment = path.split('/').filter(Boolean)[0] || '';
  return (
    segment.length <= 2         // booking paths: /db /wa /fb etc.
    || path === '/'               // root
    || path.startsWith('/unknown')     // error pages
    || path.startsWith('/review')     // review pages
    || path.startsWith('/coupon')     // review pages
  );
}

// redirect to subdomain root — works for any domain
// casagaja.ibookrestaurant.com → https://casagaja.ibookrestaurant.com/
// casagaja.aibooking.it        → https://casagaja.aibooking.it/
function redirectToSubdomainRoot() {
  window.location.href = `${window.location.protocol}//${window.location.host}/`;
}

// ─────────────────────────────────────────────────────────────────────────────
// Navigation Guard
// ─────────────────────────────────────────────────────────────────────────────

router.beforeEach((to, from, next) => {

  // 1. storage check
  if (!storageAvailable('localStorage')) {
    next({ path: '/auth/storageissue', params: { nextUrl: to.fullPath } });
    return;
  }

  // 2. ── SUBDOMAIN GUARD ──
  //    on casagaja.ibookrestaurant.com, ONLY 2-char booking paths are allowed
  //    anything else → redirect to subdomain root (e.g. casagaja.ibookrestaurant.com/)
  if (isSubdomainHost() && !isAllowedOnSubdomain(to.path)) {
    redirectToSubdomainRoot(); // ← stays on same subdomain+domain, just strips the path
    return;
  }

  const target   = sessionStorage.getItem('target');
  const jwt      = sessionStorage.getItem('jwt');
  const settings = getSettings();

  // ── PROTECTED ROUTE ────────────────────────────────────────────────────────
  if (to.matched.some(record => record.meta.requiresAuth)) {

    // not logged in
    if (!jwt || !settings) {
      if (!settings || settings.email == null) {
        next({ path: '/auth/login', params: { nextUrl: to.fullPath } });
      } else {
        next({ path: '/auth/lockscreen', params: { nextUrl: to.fullPath } });
      }
      return;
    }

    // logged in — check level
    const level = parseInt(settings.level);

    // booking customers must NOT access restaurant protected pages
    if (level < 5) {
      next({ path: '/error/403', params: { nextUrl: to.fullPath } });
      return;
    }

    // SaaS boss only
    if (to.matched.some(record => record.meta.bossOnly)) {
      if (level <= 100) {
        next({ path: '/error/403', params: { nextUrl: to.fullPath } });
        return;
      }
    }

    // all checks passed
    if (target) {
      sessionStorage.removeItem('target');
      next({ path: target, params: { nextUrl: to.fullPath } });
    } else {
      next();
    }

  // ── PUBLIC ROUTE ───────────────────────────────────────────────────────────
  } else {

    // bare root domain (no subdomain) → send to login
    const host = window.location.host.toLowerCase();
    const isRootDomain = (host === 'ibookrestaurant.com' || host === 'aibooking.it') 
                          && window.location.pathname === '/';

    if (isRootDomain && !isSubdomainHost() && to.path !== '/auth/login') {
      next({ path: '/auth/login', params: { nextUrl: to.fullPath } });
      return;
    }

    if (to.path === '/payment') {
      next({ path: '/settings/?pageId=services', params: { nextUrl: to.fullPath } });
      return;
    }

    next();
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
/*
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
  },
});

// ─────────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────────

function storageAvailable(type) {
  try {
    const storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

function getSettings() {
  try {
    const raw = sessionStorage.getItem('settings');
    return raw ? JSON.parse(raw) : null;
  } catch {
    sessionStorage.removeItem('settings');
    return null;
  }
}

// true if accessed via casagaja.ibookrestaurant.com (not www, not root)
function isSubdomainHost() {
  const parts = window.location.host.split('.');
  return parts.length > 2 && parts[0] !== 'www';
}

// on subdomain, ONLY 2-char paths are booking paths (/db /wa /fb /go ...)
// anything longer (/manage /whatsapp /manage_db) must be blocked
function isAllowedOnSubdomain(path) {
  const segment = path.split('/').filter(Boolean)[0] || '';
  return (
    segment.length <= 2 ||        // booking paths: /db /wa /fb etc.
    path === '/' ||               // root
    path.startsWith('/auth') ||   // auth pages
    path.startsWith('/error')     // error pages
  );
}

function redirectToRootLogin() {
  window.location.href = 'https://ibookrestaurant.com/auth/login';
}

// ─────────────────────────────────────────────────────────────────────────────
// Navigation Guard
// ─────────────────────────────────────────────────────────────────────────────

router.beforeEach((to, from, next) => {

  // 1. storage check
  if (!storageAvailable('localStorage')) {
    next({ path: '/auth/storageissue', params: { nextUrl: to.fullPath } });
    return;
  }

  // 2. ── SUBDOMAIN GUARD ──
  //    on casagaja.ibookrestaurant.com, ONLY 2-char booking paths are allowed
  //    regardless of JWT or level — a booking customer NEVER accesses /manage etc.
  if (isSubdomainHost() && !isAllowedOnSubdomain(to.path)) {
    redirectToRootLogin();
    return;
  }

  const target   = sessionStorage.getItem('target');
  const jwt      = sessionStorage.getItem('jwt');
  const settings = getSettings();

  // ── PROTECTED ROUTE ────────────────────────────────────────────────────────
  if (to.matched.some(record => record.meta.requiresAuth)) {

    // not logged in
    if (!jwt || !settings) {
      if (!settings || settings.email == null) {
        next({ path: '/auth/login', params: { nextUrl: to.fullPath } });
      } else {
        next({ path: '/auth/lockscreen', params: { nextUrl: to.fullPath } });
      }
      return;
    }

    // logged in — check level
    const level = parseInt(settings.level);

    // booking customers (level=0 or level=1 set by booking.php) 
    // must NOT access restaurant protected pages
    if (level < 5) {
      next({ path: '/error/403', params: { nextUrl: to.fullPath } });
      return;
    }

    // SaaS boss only
    if (to.matched.some(record => record.meta.bossOnly)) {
      if (level <= 100) {
        next({ path: '/error/403', params: { nextUrl: to.fullPath } });
        return;
      }
    }

    // all checks passed
    if (target) {
      sessionStorage.removeItem('target');
      next({ path: target, params: { nextUrl: to.fullPath } });
    } else {
      next();
    }

  // ── PUBLIC ROUTE ───────────────────────────────────────────────────────────
  } else {

    // bare root domain (no subdomain) → send to login
    const isRootDomain =
      window.location.host.toLowerCase() + window.location.pathname === 'ibookrestaurant.com/';

    if (isRootDomain && !isSubdomainHost() && to.path !== '/auth/login') {
      next({ path: '/auth/login', params: { nextUrl: to.fullPath } });
      return;
    }

    if (to.path === '/payment') {
      next({ path: '/settings/?pageId=services', params: { nextUrl: to.fullPath } });
      return;
    }

    next();
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
*/